import {Modal} from 'antd'
import {ReactComponent as StarIcon} from '@assets/svgs/start.svg'
import {
  Box,
  Center,
  Checkbox,
  CheckboxGroup,
  Flex,
  Icon,
  Stack,
  Text,
  Textarea,
} from '@chakra-ui/react'
import {useEffect, useState} from 'react'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {useDispatch, useSelector} from 'react-redux'
import {
  getFeedbackOverview,
  updateIsShowModalFeedbackRealTime,
} from '@redux/shared/shared'
import mapRequest from '@apis/map'
import appRequest from '@apis/app'
import {isLoggedIn} from '@utils'
import BackgroundDailyReview from '@assets/images/roadmap/background-daily-review.png'

const ModalFeedbackRealTime = ({feedbackKey}: {feedbackKey: string}) => {
  const {isShowModalFeedbackRealTime, dataFeedbackOverview} = useSelector(
    (state: any) => state.shared,
  )
  const [step, setStep] = useState<number>(1)
  const [selectedOptions, setSelectedOptions] = useState<string[]>([])
  const [score, setScore] = useState<number>(0)
  const [content, setContent] = useState<string>('')
  const [feedbackData, setFeedbackData] = useState<any>(null)
  const dispatch: any = useDispatch()

  useEffect(() => {
    if (feedbackKey) {
      getFeedbackData(feedbackKey)
    }
  }, [feedbackKey])

  useEffect(() => {
    if (!isShowModalFeedbackRealTime) return
    const timer = setTimeout(() => {
      dispatch(updateIsShowModalFeedbackRealTime(false))
    }, 30000)
    return () => clearTimeout(timer)
  }, [isShowModalFeedbackRealTime])

  useEffect(() => {
    if (isShowModalFeedbackRealTime) {
      const observer = new MutationObserver(mutations => {
        const modalElement = document.querySelector('.ant-modal-wrap')
        if (modalElement) {
          ;(modalElement as HTMLElement).style.width = '0px'
          observer.disconnect()
        }
      })

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      })

      return () => observer.disconnect()
    }
  }, [isShowModalFeedbackRealTime])

  const getFeedbackData = async (feedbackKey: string) => {
    try {
      const params = {
        'feedback-id':
          dataFeedbackOverview?.feedback_data[feedbackKey]?.feedback_id,
      }
      const res = await mapRequest.getFeedbackData(params)
      if (res) {
        setFeedbackData(res?.data?.data)
      }
    } catch (error) {}
  }

  const handleClickRate = (score: number) => {
    setStep(2)
    setScore(score)
  }

  const handleCloseModal = () => {
    dispatch(updateIsShowModalFeedbackRealTime(false))
    setStep(1)
  }

  const handleOptionChange = (options: string[]) => {
    setSelectedOptions(options)
  }

  const handleChangeContent = (e: any) => {
    setContent(e.target.value)
  }

  const handleSubmitFeedbackRealTime = async () => {
    try {
      let params
      if (isLoggedIn()) {
        params = {
          feedback_data_id:
            dataFeedbackOverview?.feedback_data[feedbackKey]?.feedback_id,
          score: score,
          feature: dataFeedbackOverview?.feedback_data[feedbackKey]?.feature,
          explanation: content || '',
        }
      } else {
        params = {
          feedback_data_id:
            dataFeedbackOverview?.feedback_data[feedbackKey]?.feedback_id,
          feedback_data: {
            score: score,
            feature: dataFeedbackOverview?.feedback_data[feedbackKey]?.feature,
            explanation: content || '',
          },
        }
      }
      const res = await appRequest.submitRealTimeFeedback(params)
    } catch (error) {}
    dispatch(updateIsShowModalFeedbackRealTime(false))
    setStep(1)
    dispatch(getFeedbackOverview())
  }

  return (
    <>
      <Modal
        open={isShowModalFeedbackRealTime}
        onCancel={handleCloseModal}
        mask={false} // Ensure the overlay is disabled
        maskClosable={false} // Prevent closing on outside click
        width={window.innerWidth <= 768 ? '320px' : '360px'}
        title={
          <Flex
            className="123456"
            alignItems={'center'}
            gap={'16px'}
            mr={'24px'}>
            <Center
              position={'relative'}
              w={'48px'}
              h={'48px'}
              borderRadius={'50%'}
              bg={'#FEF0C7'}
              flexShrink={0}>
              <Icon
                w={'24px'}
                h={'24px'}
                sx={{
                  path: {
                    stroke: '#DC6803',
                  },
                }}>
                <StarIcon />
              </Icon>
              <Box
                pointerEvents={'none'}
                position={'absolute'}
                top={'50% '}
                left={'50%'}
                transform={'translate(-50%, -50%)'}
                w={'300px'}
                h={'300px'}
                bgImage={BackgroundDailyReview}
                bgSize={'cover'}
                bgPosition={'center'}
              />
            </Center>
            <Flex flexDirection={'column'}>
              <Text fontSize={'16px'} fontWeight={600}>
                {(step === 1 &&
                  feedbackData &&
                  feedbackData?.feedback_data?.data[step - 1]?.text) ||
                  ''}
                {step === 2 && feedbackData && score < 5
                  ? feedbackData?.feedback_data?.data[step - 1]?.negative
                      ?.text || ''
                  : feedbackData?.feedback_data?.data[step - 1]?.positive
                      ?.text || ''}
              </Text>
              {step === 2 && (
                <Text fontSize={'14px'} fontWeight={400}>
                  Có thể chọn nhiều đáp án
                </Text>
              )}
            </Flex>
          </Flex>
        }
        footer={null}
        style={{
          top: 'auto',
          right: window.innerWidth <= 768 ? '20px' : '50px',
          bottom: window.innerWidth <= 768 ? '10px' : '20px',
          left: 'auto',
          position: 'fixed',
        }}
        styles={{
          content: {
            overflow: 'hidden',
          },
        }}>
        {step === 1 && (
          <>
            <Flex gap={'4px'} mt={'24px'}>
              {Array.from({
                length:
                  feedbackData?.feedback_data?.data[step - 1]?.total_score,
              }).map((_, index) => (
                <Center
                  key={index}
                  flex={1}
                  cursor={'pointer'}
                  p={'4px'}
                  border={'1px solid #D0D5DD'}
                  borderRadius={'8px'}
                  _hover={{
                    border: '1px solid #70BAFF',
                    bg: '#D6EBFF',
                    color: '#0069CC',
                  }}
                  onClick={() => handleClickRate(index + 1)}>
                  {index + 1}
                </Center>
              ))}
            </Flex>
            <Flex
              justifyContent={'space-between'}
              mt={'12px'}
              fontSize={'14px'}>
              <Text>{feedbackData?.feedback_data?.data[step - 1]?.min}</Text>
              <Text>{feedbackData?.feedback_data?.data[step - 1]?.max}</Text>
            </Flex>
          </>
        )}
        {step === 2 && (
          <Box mt={'24px'}>
            <CheckboxGroup
              colorScheme="blue"
              value={selectedOptions}
              onChange={handleOptionChange}>
              <Stack flexDirection={'column'}>
                {(score < 5
                  ? feedbackData?.feedback_data?.data[step - 1]?.negative
                      ?.options
                  : feedbackData?.feedback_data?.data[step - 1]?.positive
                      ?.options
                ).map((option: any, index: number) => (
                  <Checkbox key={index} value={option}>
                    {option === 'USER_INPUT' ? 'Khác' : option}
                  </Checkbox>
                ))}
              </Stack>
            </CheckboxGroup>
            {selectedOptions.includes('USER_INPUT') && (
              <Textarea
                mt={'12px'}
                w={'100%'}
                placeholder="Nhập nội dung"
                onChange={handleChangeContent}
              />
            )}
            <GlobalButton
              mt={'24px'}
              w={'100%'}
              onClick={handleSubmitFeedbackRealTime}
              isDisabled={selectedOptions.length === 0}>
              Gửi
            </GlobalButton>
          </Box>
        )}
      </Modal>
    </>
  )
}

export default ModalFeedbackRealTime
